<template>
  <client-only>
  <AppYandex/>
  <AppGtm />
  </client-only>
  <div class="wrapper">
    <Preloader />
    <AgeDisclaimer />
    <AppHeader />
    <div ref="contentContainer" class="content-container">
      <main class="main">
        <slot />
      </main>
    </div>
    <div v-show="showMap" class="map-container">
      <AppMap />
    </div>
    <CookieDisclaimer />
    <AppTooltip v-if="!isMobile && tooltip" :tooltip="tooltip"/>
    <ModalVideo v-if="showVideo" />
  </div>
</template>
<script setup lang="ts">
import allPages from '@shared/data/pages.json';
import { storeToRefs } from 'pinia';
import {ref, computed, onMounted, watch,type ComputedRef} from 'vue';
import { useLayoutStore } from "@stores/layout";
import { usePagesStore } from "@stores/pages";
import { useWindowSize } from "@vueuse/core";
import { MOBILE_BREAKPOINT } from '@utils/consts/const';
import AppHeader from "@components/AppHeader/index.vue";
import AppMap from "@components/AppMap/index.vue"
import CookieDisclaimer from "@components/CookieDisclaimer/index.vue";
import Preloader from "@components/Preloader/index.vue";
import AgeDisclaimer from "@components/AgeDisclaimer/index.vue";
import AppYandex from "@components/Metrics/AppYandex.vue";
import AppGtm from "@components/Metrics/AppGtm.vue";
import AppTooltip from "@components/AppMapTooltip/index.vue";
import ModalVideo from "@components/ModalVideo/index.vue";

const layoutStore = useLayoutStore();
const pagesStore = usePagesStore();
const { isMobile } = storeToRefs(layoutStore);
const {  currentPage , tooltip, showVideo} = storeToRefs(pagesStore)
const { width: windowWidth } = useWindowSize();
const pagesData = allPages;
const contentContainer = ref<HTMLElement | null>(null)


const checkWindowWidth = (value:number): boolean => {
  return value <= MOBILE_BREAKPOINT
}
const showMap: ComputedRef<boolean> = computed(()=>{
  return !(isMobile.value && currentPage.value !== null);


})
onMounted(():void =>{
  pagesStore.setPages( pagesData );
  isMobile.value = checkWindowWidth(windowWidth.value);
})

watch(windowWidth, (newVal): void => {
  try {
    isMobile.value = checkWindowWidth(newVal);
  } catch (error) {
    console.error('Ошибка в watch:', error);
  }
});
watch(currentPage,():void =>{
  if (!isMobile.value){
    contentContainer.value?.scrollTo({ top: 0, behavior: 'smooth' });
  } else {
    setTimeout(()=>{
      window?.scrollTo( {top: 0, behavior: 'smooth'} );
    },10);

  }

});
</script>
<style scoped lang="scss">
.wrapper{
  width: 100%;
  overflow: hidden;
  height: 100dvh;
  display: flex;
  position: relative;
  padding-top: var(--header-height);
  @media screen and (max-width: 768px){
    overflow-y: auto;
    flex-direction: column;
    overflow: unset;
  }
  .content-container{
    width: 50%;
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100dvh - var(--header-height));
    @media screen and (max-width: 769px) {
      width: 100%;
      height: auto;
      overflow-y: unset;
      overflow-x: unset;
    }

    @media screen and (min-width: 769px) {
      &::-webkit-scrollbar {
        width: .5rem; /* Width of the vertical scrollbar */
        height: .5rem; /* Height of the horizontal scrollbar */
      }
      &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: .5rem;
      }
      &::-webkit-scrollbar-thumb {
        background: var(--color-secondary);
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: var(--color-secondary); /* Darker color on hover */
      }
    }
  }
  .map-container{
    overflow: hidden;
    position: relative;
    width: 50%;
    @media screen and (max-width: 769px) {
      width: 100%;
      min-height: 55.2rem;
      height: 100%;
      overflow: unset;
    }
  }
}
</style>